<template>
    <span class="icon material-icons">{{ name }}</span>
</template>

<script>
  export default {
    name: 'Icon',

    props: {
      name: {
        type:     String,
        required: true,
      },
    },

    data () {
      return {};
    },

    computed: {},

    methods: {},
  };
</script>

<style scoped>

</style>
